// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uS9l","left":"styles_left__1bBsU","desktopActions":"styles_desktopActions__q7UPI","title":"styles_title__N2WM3"};